export const UPDATE_OBJECT = "UPDATE_OBJECT";
export const SET_VISIBILITY = 'SET_VISIBILITY'

export const VisibilityFilters = {
  SHOW_STAGE1: 'SHOW_STAGE1',
  SHOW_STAGE2: 'SHOW_STAGE2',
  SHOW_STAGE3: 'SHOW_STAGE3',
  SHOW_THANKYOU: 'SHOW_THANKYOU'
}